/* eslint-disable no-undef */
// eslint-disable-next-line no-undef

declare let API_URL: string;
declare let NODE_ENV: string;
declare let ADMIN_URL: string;
declare let GA4_KEY: string;
declare let APPINSIGHTS_CONNECTION_STRING: string;
declare let GTM_ID: string;
declare let RECAPTCHA_KEY: string;
declare let BUILD_VERSION: string;
declare let ENVIRONMENT: string;

export const appEnv = {
  isDevelopment: NODE_ENV === "development",
  environment: ENVIRONMENT,
  appVersion: BUILD_VERSION,
  adminUrl: ADMIN_URL,
  apiUrl: API_URL,
  ga4Key: GA4_KEY,
  appInsightsConnectionString: APPINSIGHTS_CONNECTION_STRING,
  recaptchaKey: RECAPTCHA_KEY,
};
